<div>
    <form [formGroup]="form" class="border-bottom-separator mb-3">
        <div class="row mb-4 mt-4">
            <div class="col-12 mb-2">
                <p>{{ modalConfig.textDescription | translate }}</p>
            </div>
            <div class="col-12">
                <label for="name">{{ modalConfig.inputLabel | translate }}</label>
                <input
                    type="text"
                    pInputText
                    id="name"
                    formControlName="name"
                    [placeholder]="modalConfig.inputPlaceholder ? (modalConfig.inputPlaceholder | translate) : ''"
                    class="w-100"
                    required="true"
                />
            </div>
        </div>
    </form>

    <div class="row">
        <div class="col-12 d-flex justify-content-end">
            <p-button
                severity="secondary"
                [label]="
                    modalConfig.cancelButtonLabel
                        ? (modalConfig.cancelButtonLabel | translate)
                        : ('COMMON.BUTTONS.CANCEL' | translate)
                "
                (onClick)="onCancel()"
                class="me-2"
            ></p-button>
            <p-button
                severity="primary"
                [label]="
                    modalConfig.createButtonLabel
                        ? (modalConfig.createButtonLabel | translate)
                        : ('COMMON.BUTTONS.CREATE' | translate)
                "
                (onClick)="onCreate()"
                [disabled]="!isFormValid"
            ></p-button>
        </div>
    </div>
</div>
